import { getMessageTemplates } from "@api";
import { updateMessageTemplate as updatePermission } from "@auth";
import { PageHeader, PageTitle } from "@components";
import { useEffect, useState } from "react";
import TemplateGrid from "../components/TemplateGrid";
import CreateTemplate from "../flows/CreateTemplate";
import DeleteTemplate from "../flows/DeleteTemplate";
import EditTemplate from "../flows/EditTemplate";

const Templates = () => {
  const [templates, setTemplates] = useState([]);
  const [createFormOpen, setCreateFormOpen] = useState(false);
  const [editTemplate, setEditTemplate] = useState(null);
  const [deletedTemplate, setDeletedTemplate] = useState(null);

  useEffect(() => {
    async function fetchData() {
      const data = await getMessageTemplates();
      setTemplates(data);
    }

    fetchData();
  }, []);

  const onDeleteComplete = async () => {
    const data = await getMessageTemplates();
    setTemplates(data);
    setDeletedTemplate(null);
  };

  const onEditComplete = async () => {
    const data = await getMessageTemplates();
    setTemplates(data);
    setEditTemplate(null);
  };

  const onCreateComplete = async () => {
    const data = await getMessageTemplates();
    setTemplates(data);
    setCreateFormOpen(false);
  };

  const actions = [
    {
      label: "New template",
      onClick: () => setCreateFormOpen(true),
      color: "primary",
      permission: updatePermission,
    },
  ];

  const rowActions = [
    {
      label: "Edit",
      onClick: (x) => setEditTemplate(x),
      permission: updatePermission,
    },
    {
      label: "Delete",
      onClick: (x) => setDeletedTemplate(x),
      permission: updatePermission,
      show: (x) => !x.isDefault,
    },
  ];

  return (
    <>
      <PageHeader>
        <PageTitle>Templates</PageTitle>
      </PageHeader>
      <TemplateGrid
        data={templates}
        actions={actions}
        rowActions={rowActions}
      />
      <CreateTemplate
        isOpen={createFormOpen}
        onComplete={() => onCreateComplete()}
        onClose={() => setCreateFormOpen(false)}
      />
      <DeleteTemplate
        templateId={deletedTemplate?.id}
        isOpen={!!deletedTemplate}
        onComplete={() => onDeleteComplete()}
        onClose={() => setDeletedTemplate(null)}
      />
      <EditTemplate
        template={editTemplate}
        isOpen={!!editTemplate}
        onComplete={() => onEditComplete()}
        onClose={() => setEditTemplate(null)}
      />
    </>
  );
};

export default Templates;
